module.exports = __webpack_public_path__ + "static/media/icon-filter.d791e0b0.svg";